import {
  CheckIcon,
  MusicIcon,
  LinkIcon,
  IgProductTagIcon,
  IgTextIcon,
  HashtagIcon,
  PlusIcon,
} from '@buffer-mono/popcorn'
import { PostFields } from '@buffer-mono/reminders-config'

import * as Styled from './styles'

function getIcon(icon: PostFields): JSX.Element {
  switch (icon) {
    case PostFields.MUSIC:
      return <MusicIcon />
    case PostFields.LINK:
      return <LinkIcon />
    case PostFields.OTHER:
      return <PlusIcon />
    case PostFields.TEXT:
      return <IgTextIcon />
    case PostFields.TOPICS:
      return <HashtagIcon />
    case PostFields.PRODUCTS:
      return <IgProductTagIcon />
  }

  return <MusicIcon />
}

export function StickerSelect({
  name,
  text,
  onChange,
  checked,
  icon,
}: {
  name: string
  text: string
  onChange: (e: { target: HTMLInputElement }) => void
  checked: boolean
  icon?: PostFields
}): JSX.Element {
  return (
    <Styled.Label htmlFor={name}>
      {icon && (checked ? <CheckIcon /> : getIcon(icon))}
      {text}
      <Styled.Input
        type="checkbox"
        name={name}
        id={name}
        onChange={onChange}
        checked={checked}
      ></Styled.Input>
    </Styled.Label>
  )
}
